// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { call, put, takeEvery, fork, delay, select } from "redux-saga/effects";
import axios from "axios";
import * as actions from "actions";
import api from "api";
import * as Types from "Types";

const baseUri = "//14.49.39.56:3000"; //?pageNum=1&pageSize=15";

function* getExhibitions(action: any) {
   const instance = axios.create({ baseURL: baseUri });

   instance.interceptors.request.use(function (req) {
      const formData = new FormData();

      console.log("req", req);

      const data = req.data || req.params;

      Object.keys(data).forEach(function (k) {
         formData.append(k, data[k]);
      });
      req.headers = { "Content-Type": "aplication/json" };
      req.data = formData;
      req.params = formData;

      return req;
   });
   instance.interceptors.response.use((res) => {
      return {
         code: res.status,
         data: res.data.data || [],
         message: res.data.message || "",
      };
   });

   const status: string = yield select(function (state: any) {
      return state.exhibitions.get.status;
   });
   if (status === api.statuses.pending) return;
   try {
      yield put({
         type: actions.exhibitions.get.send,
      });

      // const { data } = yield call([axios, "post"], testUri, { pageNum: 1, pageSize: 15 });
      // const response: Types.Api.Response = yield call(instance.get, testUri);
      const response: Types.Api.Response = yield call(instance, "/test.json", { method: "get", params: { page: 1, pageSize: 100 } });
      console.log("response", response);
      yield put({
         type: actions.exhibitions.get.success,
         payload: { code: 200, data: response.data },
      });
   } catch (error) {
      console.log("error", error);
      yield put({
         type: actions.exhibitions.get.fail,
         payload: {
            code: 400,
            message: "파라미터가 올바르지 않음",
         },
      });
   }
}

export function* exhibitionsSaga() {
   yield takeEvery(actions.exhibitions.get.call, getExhibitions);
}
